<script>

export default {
    name: 'dkbr-button-dial',
    txtDescr: 'Dial button. Default slot may be used for action-buttons',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        posx: {
            name: 'posx',
            type: String,
            enum: ['left', 'center', 'right'],
            txtDescr: `X-position of the element`,
            default: _ => 'left',
        },
        posy: {
            name: 'posy',
            type: String,
            enum: ['top', 'bottom'],
            txtDescr: `Y-position of the element`,
            default: _ => 'top',
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['top', 'bottom'],
            txtDescr: `Direction of content expansion`,
            default: _ => 'top',
        },
        effect: {
            name: 'effect',
            type: String,
            enum: ['fling', 'scale', 'opacity'],
            txtDescr: `Effect then expands`,
            default: _ => 'fling',
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: `Icon for display`,
            default: _ => 'add',
        },
        iconFinal: {
            name: 'iconFinal',
            type: String,
            txtDescr: `Icon for display then opened`,
            default: _ => '',
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: `Icon size`,
            default: _ => 1,
        },
        isHover: {
            name: 'isHover',
            type: Boolean,
            txtDescr: `If true, will opened on hover`,
            default: _ => false,
        },
        isDemo: {
            name: 'isDemo',
            type: Boolean,
            txtDescr: `If true, the demo content will be generated`,
            default: _ => false,
        },
    },
}
</script>

<template lang="pug">

md-speed-dial(
    :md-theme="isThInv ? th+'i' : th"
    :class="['md-primary', `md-${posy}-${posx}`]"
    :md-direction="dir"
    :md-effect="effect"
    :md-event="isHover ? 'hover' : 'click'")
    md-speed-dial-target
        dkbr-icon(
            v-if="icon"
            :th="th"
            :isThInv="isThInv"
            :class=`{'md-morph-initial': iconFinal}`
            :name="icon"
            :size="iconSize")
        dkbr-icon(
            v-if="iconFinal"
            :th="th"
            :isThInv="isThInv"
            :class=`{'md-morph-final': iconFinal}`
            :name="iconFinal"
            :size="iconSize")
    md-speed-dial-content
        slot
            dkbr-button(
                v-if="isDemo" :th="th" :isThInv="isThInv" icon="directions")
            dkbr-button(
                v-if="isDemo" :th="th" :isThInv="isThInv" icon="streetview")
            dkbr-button(
                v-if="isDemo" :th="th" :isThInv="isThInv" icon="note")
            dkbr-button(
                v-if="isDemo" :th="th" :isThInv="isThInv" icon="event")
            dkbr-button(
                v-if="isDemo" :th="th" :isThInv="isThInv" icon="close")
</template>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/button/vue/ButtonDial.vue